import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';
import {
    Form, Checkbox, Button, InputNumber, message,
} from 'antd';
import { urlKamar, urlJadwal } from '../../config';

class SslideForm extends PureComponent {

    state = {
        isJadwalChecked: true,
        isKamarChecked: true
    }

    componentDidMount = () => {
        let defConfig = JSON.parse(localStorage.getItem('configApp'));

        let isJadwalChecked = defConfig.show_order.indexOf('jd') === -1 ? false : true;

        let isKamarChecked = defConfig.show_order.indexOf('tt') === -1 ? false : true;

        defConfig.isJadwalChecked = isJadwalChecked;
        defConfig.isKamarChecked = isKamarChecked;

        this.setState(defConfig, () => this.getConfig());
    }

    getConfig = () => {
        // console.log(this.state);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let data = {};

                data.tt = {
                    title: 'INFORMASI TEMPAT TIDUR',
                    key: 'tt',
                    autoplaySpeed: values['autoplaySpeed_kamar'],
                    urlData: urlKamar
                };

                data.jd = {
                    title: 'JADWAL DOKTER',
                    key: 'jd',
                    autoplaySpeed: values['autoplaySpeed_jadwal'],
                    urlData: urlJadwal
                }

                let show_order = [];

                if (values['show_order_kamar'] < values['show_order_jadwal']) {
                    if (values['informasi_kamar']) show_order.push('tt');
                    if (values['jadwal_dokter']) show_order.push('jd');
                } else {
                    if (values['jadwal_dokter']) show_order.push('jd');
                    if (values['informasi_kamar']) show_order.push('tt');
                }

                if (show_order.length > 0) {
                    this.setState({
                        data: data,
                        show_order: show_order,
                        active_slide: show_order[0]
                    }, () => this.saveToLocal());

                    message.success("Setting Tersimpan.");
                } else {
                    message.error("Minimal terpilih slide harus 1.");
                }
            }
        });
    }

    saveToLocal = () => {
        let defConfig = JSON.parse(localStorage.getItem('configApp'));

        let newConfig = Object.assign({}, defConfig, {
            isJadwalChecked: this.state.isJadwalChecked,
            isKamarChecked: this.state.isKamarChecked,
            data: this.state.data,
            show_order: this.state.show_order,
            active_slide: this.state.show_order[0]
        });

        localStorage.setItem('configApp', JSON.stringify(newConfig));
    }

    onChangeKamar = () => {
        this.setState({
            isKamarChecked: this.state.isKamarChecked ? false : true
        })
    }

    onChangeJadwal = () => {
        this.setState({
            isJadwalChecked: this.state.isJadwalChecked ? false : true
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        //const { autoCompleteResult } = this.state;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        const style = {
            marginBottom: 0
        }

        return (
            <div>
                <Form onSubmit={this.handleSubmit} hideRequiredMark>
                    <Form.Item {...formItemLayout}>
                        <Form.Item style={style}>
                            {getFieldDecorator('informasi_kamar', {
                                rules: [{
                                    required: false, message: 'Ukuran Font tidak boleh kosong!',
                                }],
                                initialValue: true
                            })(
                                <Checkbox
                                    key={'k_kmr'}
                                    checked={this.state.isKamarChecked}
                                    onChange={this.onChangeKamar}
                                //defaultChecked={this.state.isKamarChecked}
                                >
                                    Informasi Kamar</Checkbox>
                            )}
                        </Form.Item>
                        <Form.Item style={style} label="Auto Play Speed">
                            {getFieldDecorator('autoplaySpeed_kamar', {
                                rules: [{
                                    required: true, message: 'Auto Play speed kamar tidak boleh kosong!',
                                }],
                                initialValue: typeof this.state.data === "undefined" ? 3000 : this.state.data.tt.autoplaySpeed
                            })(
                                <InputNumber />
                            )}
                        </Form.Item>
                        <Form.Item style={style} label="Show Order">
                            {getFieldDecorator('show_order_kamar', {
                                rules: [{
                                    required: true, message: 'Show order kamar tidak boleh kosong!',
                                }],
                                initialValue: typeof this.state.show_order === "undefined" ? 1 : this.state.show_order.indexOf(this.state.data.tt.key) + 1
                            })(
                                <InputNumber />
                            )}
                        </Form.Item>
                        <Form.Item style={style} >
                            {getFieldDecorator('jadwal_dokter', {
                                rules: [{
                                    required: false, message: 'Ukuran Font tidak boleh kosong!',
                                }],
                            })(
                                <Checkbox
                                    key={'k_jd'}
                                    checked={this.state.isJadwalChecked}
                                    onChange={this.onChangeJadwal}>
                                    Jadwal Dokter</Checkbox>
                            )}
                        </Form.Item>
                        <Form.Item style={style} label="Auto Play Speed">
                            {getFieldDecorator('autoplaySpeed_jadwal', {
                                rules: [{
                                    required: true, message: 'Auto Play speed jadwal tidak boleh kosong!',
                                }],
                                initialValue: typeof this.state.data === "undefined" ? 4000 : this.state.data.jd.autoplaySpeed
                            })(
                                <InputNumber />
                            )}
                        </Form.Item>
                        <Form.Item style={style} label="Show Order">
                            {getFieldDecorator('show_order_jadwal', {
                                rules: [{
                                    required: true, message: 'Show order jadwal tidak boleh kosong!',
                                }],
                                initialValue: typeof this.state.show_order === "undefined" ? 2 : this.state.show_order.indexOf(this.state.data.jd.key) + 1
                            })(
                                <InputNumber />
                            )}
                        </Form.Item>
                    </Form.Item>
                    <Form.Item {...tailFormItemLayout}>
                        <Button type="primary" htmlType="submit">Terapkan</Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

const WrappedSslideForm = Form.create({ name: 'SslideForm' })(SslideForm);

SslideForm.propTypes = {

};

export default WrappedSslideForm;